import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { formatSqlDate } from "../../../utils/normalize";

export default ({ onDeleteClick }) => [
  {
    dataField: "utc_date",
    text: "Created Date (UTC)",
    formatter: (utc_date) => formatSqlDate(utc_date),
  },
  {
    dataField: "email",
    text: "Email Address",
  },
  // {
  //   dataField: "ip",
  //   text: "IP Address",
  // },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, spamRecord) => (
      <Fragment>
        <Link to="#" onClick={() => onDeleteClick(spamRecord)}>
          <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
        </Link>
      </Fragment>
    ),
  },
];
